import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { consumeTotalKlickCallback } from "@/lib/totalklick";
import { Loader2, ShieldCheck, AlertCircle } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export default function SSOCallback() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { token, user } = await consumeTotalKlickCallback(params, API);
        if (cancelled) return;
        try { localStorage.setItem("gs_token", token); } catch { /* ignore */ }
        try { localStorage.setItem("gs_user", JSON.stringify(user || {})); } catch { /* ignore */ }
        const dest = user?.role === "superadmin" ? "/admin" : "/dashboard";
        navigate(dest, { replace: true });
      } catch (e) {
        if (!cancelled) setError(e?.message || "Errore SSO");
      }
    })();
    return () => { cancelled = true; };
  }, [params, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-[#FFF8F2] to-[#EFF4FF] p-6">
      <div className="max-w-md w-full bg-white border border-slate-200 rounded-3xl p-8 shadow-sm text-center" data-testid="sso-callback">
        {error ? (
          <>
            <div className="w-14 h-14 mx-auto rounded-full bg-rose-100 text-rose-600 flex items-center justify-center mb-4">
              <AlertCircle className="w-7 h-7" />
            </div>
            <h1 className="text-2xl font-black text-[#1E293B] mb-2">Accesso non riuscito</h1>
            <p className="text-sm text-slate-600 mb-6" data-testid="sso-callback-error">{error}</p>
            <button onClick={() => navigate("/login")} className="px-5 py-3 rounded-xl bg-[#1E293B] text-white font-bold text-sm">
              Torna al login
            </button>
          </>
        ) : (
          <>
            <div className="w-14 h-14 mx-auto rounded-full bg-[#2456C6]/10 text-[#2456C6] flex items-center justify-center mb-4">
              <ShieldCheck className="w-7 h-7" />
            </div>
            <h1 className="text-2xl font-black text-[#1E293B] mb-2">Accesso in corso…</h1>
            <p className="text-sm text-slate-600 mb-4">Stiamo verificando la tua identità con TotalKlick.</p>
            <Loader2 className="w-6 h-6 animate-spin text-[#2456C6] mx-auto" />
          </>
        )}
      </div>
    </div>
  );
}
